import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="topo-dark w-full bg-forest" data-id="element-114" data-mp="1o5q1qgnuw7zz">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-20" data-id="element-115" data-mp="221bvf151bfyq">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-2 border-ember text-ember" data-id="element-116" data-mp="1x4uxxgby3p8z">
          <span className="font-display text-4xl leading-none" data-id="element-117" data-mp="19cek5hz8qjfh">7</span>
          <span className="text-xs font-bold uppercase tracking-widest" data-id="element-118" data-mp="14hh9y7q86410">Days</span>
        </div>
        <p className="eyebrow mt-6 text-ember" data-id="element-119" data-mp="1j6554cw5sbqf">Zero risk</p>
        <h2 id="guarantee-heading" className="trail-underline mt-3 font-display text-[30px] leading-tight text-paper sm:text-5xl" data-id="element-120" data-mp="1edc0rq4lr5ev">
          Open everything. Run a class from it.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-paper/80" data-id="element-121" data-mp="lodd6dhpnb26">
          Read the volumes, pick a plan, run it with your group. If Vivencia
          Ready doesn&apos;t change how you prepare and hold your classes, email
          us within 7 days and you get every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-122" data-mp="yqe2g1o3oygx">
          {chips.map(chip => <li key={chip} className="rounded-full border border-paper/25 px-4 py-2 text-[13px] text-paper/80" data-id="element-123" data-mp="12pmtgyrrai8s">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}